import apiClient from "../apiClient";

export const OvertimeAPI = {
  createOvertimeRequest: ({
    shiftDate,
    otType,
    otStart,
    otEnd,
    totalOtMinutes,
    reason,
    mediaID,
  }) =>
    apiClient.post("/api/v1/requests/overtime", {
      ShiftDate: shiftDate,
      OTType: otType,
      OTStart: otStart,
      OTEnd: otEnd,
      TotalOTMinutes: totalOtMinutes,
      Reason: reason,
      MediaID: mediaID,
    }),

  getAllOvertimeRequestsPaginated: ({ page, pageSize, filters }) => {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters || {}).filter(([_, value]) => value !== null)
    );

    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      ...cleanFilters,
    });
    return apiClient.get(`/api/v1/requests/overtime?${params.toString()}`);
  },
};
